const TYPES = {
  ROCK: 'ROCK',
  PAPER: 'PAPER',
  SCISSORS: 'SCISSORS',
  LIZARD: 'LIZARD',
  SPOCK: 'SPOCK'
}

const DIFFICULTY = {
  NOVICE: 'NOVICE',
  PRO: 'PRO'
}

const CONST = {
  LOCAL_STORAGE_SCORE_KEY: 'score',
  GAME_STATE: {
    PICK: 'PICK',
    USER_PICKED: 'USER_PICKED',
    RESULT: 'RESULT'
  },
  RESULT: {
    USER: 'USER',
    COMPUTER: 'COMPUTER',
    TIE: 'TIE'
  },
  TYPES,
  DIFFICULTY,
  WHO_BEATS_WHO: {
    [DIFFICULTY.NOVICE]: {
      [TYPES.PAPER]: [TYPES.ROCK],
      [TYPES.ROCK]: [TYPES.SCISSORS],
      [TYPES.SCISSORS]: [TYPES.PAPER]
    },
    [DIFFICULTY.PRO]: {
      [TYPES.PAPER]: [TYPES.ROCK, TYPES.SPOCK],
      [TYPES.ROCK]: [TYPES.SCISSORS, TYPES.LIZARD],
      [TYPES.SCISSORS]: [TYPES.PAPER, TYPES.LIZARD],
      [TYPES.LIZARD]: [TYPES.SPOCK, TYPES.PAPER],
      [TYPES.SPOCK]: [TYPES.SCISSORS, TYPES.ROCK]
    }
  }
}

export default CONST
